module.exports = __webpack_public_path__ + "static/media/6.6.42695546.png";